<script>
import TableNav from '../components/board/TableNav'
import TableSearch from '../components/board/TableSearch'

export default {
  components: { TableNav, TableSearch },
  methods: {
    setPage(index) {
      this.pagination.page = index
      window.scrollTo(0, 0)
    },
    // paginate(entries) {
    //   const start = this.pagination.page * this.pagination.perPage
    //   return [...entries].splice(start, this.pagination.perPage)
    // },
  },
}
</script>
